import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspConversionPixelService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_TDSP_URL}/image-pixel/`;

  getPixelTag(params:any) {   
    let url = this.buildUrl(`${this.resource_url}tag/`, "", params);
    return this.get(url);
  }
  //conversion Pixel Tag
  getBulkPixelTags(params :any) {
    let url = this.buildUrl(`${this.resource_url}tag/`, "", params);
    return this.get(url);
  }
}
